import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip, Row, Col } from "react-bootstrap";
import { FiEdit3, FiEye } from "react-icons/fi";
import { FaRegTrashAlt } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import toastr from "toastr";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";

import { ACTIVE_MODULE, moduleType } from "app/_constants/constant";
// import { SetGlobalPermission } from "app/Components/SetPermission/Permissions";
import {
  getAllIncidents,
  deleteIncidentDetails,
} from "app/_services/ehs/ehsIncidentServices";
import {
  capitalizeName,
  contractorDesignationLabel,
  contractorDropdownLabel,
  employeeDesignationLabel,
  employeeDropdownLabel,
  formatDDMMYYYYbyYYYYMMDD,
  fullNameLabel,
  paginationOptionsObj,
} from "app/_helpers/helper";
import {
  incidentStatuses,
  incidentTypes,
  severities,
  // incidentStatusesPermission,
  getIncidentStatusClass,
  getIncidentSeverityClass,
  incidentFilterFields,
  validateRowFilter,
  CURRENT_SEVERITY,
  staffType,
  TAB_STATUS_COUNT,
  INCIDENT_STATUS_VIEW,
  checkInvestigatorOverDue,
  checkCapaReturned,
  checkCapaOverDue,
  checkStatusByFilter,
  checkLtiWithType,
} from "./CONSTANTS";

import BackBtn from "app/Components/CommanComponents/BackBtn";

import {
  isUserRO,
  isUserMM,
  isUserSO,
  getLoggedInUserId,
  checkStringsAreEqual,
  checkUserIsOfSameSite,
} from "../IncidentManagement/Helper";
import { filterActionAdd } from "../TrainingManagement/Assign/ReducerForAssign";
import IncidentFilters from "./IncidentFilters.component";
import { useForm } from "app/_helpers/hooks";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  DDMMYYYYFormat,
  isBetween,
  isBefore,
  YYYYMMDDFormat,
} from "app/_helpers/dateHelper";
import { GiReturnArrow } from "react-icons/gi";
import moment from "moment";
import { isArray } from "lodash";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import DeleteRecordIcon from "app/Components/DeleteRecordIcon/DeleteRecordIcon";

const { SearchBar } = Search;

const initialFilter = {
  departmentId: "",
  siteId: "",
  workAreaId: "",
  severity: "",
  severityPostReview: "",
  type: "",
  closer: "",
  incidentStatus: "All",
  lti: "",
  approvalfilter: false,
};

const ManageIncidents = ({
  match: {
    params: { siteId },
  },

  viewIncident,
}) => {
  const filterStatus = useSelector((state) => state.filterReducerTraining);

  const [filter, setFilter] = useState(
    filterStatus?.manageIncident?.incidentStatus
      ? { ...filterStatus?.manageIncident }
      : { ...initialFilter }
  );
  const [incidents, setIncidents] = useState([]);
  const [incidentsFilter, setIncidentsFilter] = useState([]);
  const [statusTabFilter, setStatusTabFilter] = useState([]);

  const [incidentsTable, setIncidentsTable] = useState([]);
  // const [filterForm, onChangeFilter, setFilterForm] = useForm({}, incidentFilterFields);
  const [filterForm, setFilterForm] = useState({});
  const [searchFilter, setSearchFilter] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [filterFlag, setFilterFlag] = useState(false);
  const [loading, setLoading] = useState(true);

  // console.log("filterForm+++", filterForm);

  const dispatchFunction = useDispatch();

  const onChangeFilter = ({ target: { name, value } }) => {
    setFilter((prev) => ({ ...prev, incidentStatus: "All" }));
    setFilterFlag(false);
    setFilterForm((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const onChange = useCallback(({ target: { name, value } }) => {
    if (value !== "All") setFilterFlag(true);
    else setFilterFlag(false);
    setFilter((prev) => ({ ...prev, [name]: value }));
  }, []);

  const checkViewAndEditPermission = useCallback(
    (row) => {
      //let globalPermissions = JSON.parse(localStorage.getItem("globalPermissions"));
      let viewPage = "review";
      let editPage = "review";

      let investigatorId = row?.investigationDetails?.investigator.id;
      let currentId = getLoggedInUserId();
      if (
        checkStringsAreEqual(
          row.incidentStatus,
          incidentStatuses.investigationProgress
        ) &&
        investigatorId == currentId
      ) {
        viewPage = "review";
        editPage = "investigation";
      }

      let viewLink = null;
      if (viewPage) {
        viewLink =
          (siteId ? `/sites/${siteId}` : "") +
          "/health-safety-and-environment/incident-management/" +
          viewPage +
          "/view/" +
          row.id;
      }

      let editLink = null;
      if (editPage) {
        editLink =
          (siteId ? `/sites/${siteId}` : "") +
          "/health-safety-and-environment/incident-management/" +
          editPage +
          "/edit/" +
          row.id;
      }

      return { viewLink, editLink };
    },
    [siteId]
  );

  useEffect(() => {
    setIncidentsTable(
      incidents.filter((data) => {
        if (filter.workAreaId && +data.workAreaId !== +filter.workAreaId) return false;
        if (filter.siteId && +data.siteId !== +filter.siteId) return false;
        if (filter.departmentId && +data.departmentId !== +filter.departmentId)
          return false;
        if (filter.closer && +data.closer !== +filter.closer) return false;
        if (filter.type && data.type !== filter.type) return false;
        if (filter.severity && data.severity !== filter.severity) return false;
        if (
          filter.severityPostReview &&
          data.severityPostReview !== filter.severityPostReview
        )
          return false;
        if (
          filter.incidentStatus === incidentStatuses?.investigationReturned &&
          !data.investigationDetails?.reverted
        ) {
          return false;
        } else if (
          filter.incidentStatus === incidentStatuses?.mmReview &&
          data.incidentStatus === incidentStatuses?.mmReview &&
          data.investigationDetails?.reverted
        ) {
          return false;
        } else if (
          filter.incidentStatus === incidentStatuses?.investigationOverDue &&
          data.incidentStatus === incidentStatuses?.investigationProgress &&
          checkInvestigatorOverDue(data.investigationDetails?.targetCompletionDate)
        ) {
          return true;
        } else if (
          filter.incidentStatus === incidentStatuses?.investigationProgress &&
          data.incidentStatus === incidentStatuses?.investigationProgress &&
          checkInvestigatorOverDue(data.investigationDetails?.targetCompletionDate)
        ) {
          return false;
        } else if (
          filter.incidentStatus === incidentStatuses?.CapaReturned &&
          data.incidentStatus === incidentStatuses?.capaAssigned &&
          checkCapaReturned(data?.capas)
        ) {
          return true;
        } else if (
          filter.incidentStatus === incidentStatuses?.CapaOverDue &&
          data.incidentStatus === incidentStatuses?.capaAssigned &&
          checkCapaOverDue(data?.capas) &&
          !checkCapaReturned(data?.capas)
        ) {
          return true;
        } else if (
          filter.incidentStatus === incidentStatuses?.capaAssigned &&
          data.incidentStatus === incidentStatuses?.capaAssigned &&
          (checkCapaReturned(data?.capas) || checkCapaOverDue(data?.capas))
        ) {
          return false;
        } else if (
          filter.incidentStatus !== incidentStatuses?.investigationReturned &&
          filter.incidentStatus !== "All" &&
          data.incidentStatus !== filter.incidentStatus
        ) {
          return false;
        }
        if (filter.lti) {
          let lti = data.personalDetails.filter(
            (obj) => obj.ltiHours !== "" && obj.ltiHours !== "0" && obj.ltiHours !== 0
          );
          if (filter.lti === "Yes" && lti.length === 0) return false;
          if (filter.lti === "No" && lti.length !== 0) return false;
        }
        return true;
      })
    );
  }, [filter, incidents]);

  console.log("checkFilter", filter);

  const fetchData = useCallback(async () => {
    try {
      const response = await getAllIncidents(siteId ? `filter[siteId]=${siteId}` : "");

      if (!response?.data) {
        // Handle the case where data is not received
        setLoading(false);
        return;
      }

      setIncidents(
        response?.data?.incidentDetails
          .filter((data) => (data.incidentStatus === "Draft" ? false : true))
          ?.map((inc, idx) => {
            const severity = CURRENT_SEVERITY(inc);
            return {
              ...inc,
              sid: idx + 1,
              formattedType: incidentTypes[inc?.type],
              formattedIncidentDate: DDMMYYYYFormat(inc?.incidentDate),
              formattedReportedBy:
                inc?.staffType === "employee"
                  ? // ? `${employeeDropdownLabel(inc?.staffData)}`
                    `${fullNameLabel(inc?.staffData)}`
                  : inc?.staffType === "contractor"
                  ? // ? `${contractorDropdownLabel(inc?.staffData)}`
                    `${fullNameLabel(inc?.staffData)}`
                  : inc?.otherStaffName,
              formattedDesignation:
                inc?.staffType === "employee"
                  ? `${employeeDesignationLabel(inc?.staffData)}`
                  : inc?.staffType === "contractor"
                  ? `${contractorDesignationLabel(inc?.staffData)}`
                  : "NA",
              formattedSeverity: (
                <div className={getIncidentSeverityClass(severity)}>
                  {severities[severity]}
                </div>
              ),
              formattedIncidentStatus: INCIDENT_STATUS_VIEW(
                inc?.incidentStatus,
                inc?.investigationDetails?.reverted,
                inc?.isBack,
                inc
              ),
              formattedStaffType: staffType[inc?.staffType],
            };
          })
      );

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error as needed, e.g., show an error message
      setLoading(false);
    }
  }, [siteId]);

  useEffect(() => {
    fetchData();
  }, [fetchData, siteId]);

  useEffect(() => {
    if (filterForm.hasOwnProperty("ltiHoursUpdate") && filterForm.ltiHoursUpdate === "")
      delete filterForm.ltiHoursUpdate;
    if (
      filterForm.hasOwnProperty("reportEvidencesRequired") &&
      filterForm.reportEvidencesRequired === ""
    )
      delete filterForm.reportEvidencesRequired;

    const finalFilterList = incidentsTable?.filter?.((data) => {
      let flag = true;

      if (filterForm?.startDate && filterForm?.endDate) {
        flag = isBetween(
          YYYYMMDDFormat(data?.incidentDate),
          YYYYMMDDFormat(filterForm.startDate),
          YYYYMMDDFormat(filterForm.endDate)
        );
      }
      if (filterForm?.bodyParts) {
        const bodyPartObj = data?.personalDetails?.find((d) =>
          d.bodyParts?.split(",")?.includes(filterForm?.bodyParts)
        );
        if (!bodyPartObj) flag = false;
      }

      if (filterForm?.injuryOutcome) {
        const Obj = data?.personalDetails?.find(
          (d) =>
            d.outcome.toString().toLowerCase().replace(/\s/g, "") ===
            filterForm?.injuryOutcome.toString().toLowerCase().replace(/\s/g, "")
        );
        if (!Obj) flag = false;
      }

      if (+filterForm?.ltiHoursUpdate === 0 || +filterForm?.ltiHoursUpdate === 1) {
        const isLtiHoursUpdate =
          checkLtiWithType.includes(data?.type) &&
          data?.isPersonalInjury &&
          data?.ltiHoursUpdate === +filterForm?.ltiHoursUpdate;
        if (!isLtiHoursUpdate) flag = false;
      }

      if (
        +filterForm?.reportEvidencesRequired === 0 ||
        +filterForm?.reportEvidencesRequired === 1
      ) {
        const evidenceFlag = !!(
          (+filterForm?.reportEvidencesRequired && data?.reportEvidencesRequired) ||
          (!+filterForm?.reportEvidencesRequired && !data?.reportEvidencesRequired)
        );
        if (!evidenceFlag) flag = false;
      }

      if (
        isArray(filterForm?.generalReasonsFilter) &&
        filterForm?.generalReasonsFilter.length
      ) {
        const areAllPropertiesTrue = filterForm.generalReasonsFilter.every(
          (property) => data?.[property] === true
        );
        if (!areAllPropertiesTrue) {
          flag = false;
        }
      }

      if (filterForm?.incidentStatus && flag) {
        flag = checkStatusByFilter(filterForm?.incidentStatus, data);
      }

      if (flag) flag = validateRowFilter(filterForm, data);

      return flag;
    });

    setIncidentsFilter(finalFilterList);
    setStatusTabFilter((Prev) => (!filterFlag ? finalFilterList : Prev));
  }, [filter.incidentStatus, filterFlag, filterForm, incidentsTable]);

  // console.log("filterForm", filterForm);

  const isUserInvestigatorOfIncident = useCallback((row) => {
    let isInvetigator = false;
    let investigatorId = row?.investigationDetails?.investigator.id;
    let currentId = getLoggedInUserId();
    if (investigatorId == currentId) {
      isInvetigator = true;
    }
    return isInvetigator;
  }, []);

  const rowStyle = (row) => {
    if (row.isBack) {
      return { backgroundColor: "#d2ced6" };
    }
  };

  const sortableColumn = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "incidentId",
        text: "Incident Id",
        sort: true,
        formatter: (incidentId, row) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">View</Tooltip>}
          >
            <Link
              className="icons text-cyanBlue"
              to={`${
                siteId ? `/sites/${siteId}` : ""
              }/health-safety-and-environment/incident-management/report/view/${row.id}`}
            >
              {incidentId}
            </Link>
          </OverlayTrigger>
        ),
      },
      {
        dataField: "site.siteId",
        text: "Location Code",
        sort: true,
        formatter: (cell, row) => {
          return (
            <span
              title={row?.site ? row?.site?.name : ""}
              className="icons text-cyanBlue"
            >
              {cell}
            </span>
          );
        },
      },
      {
        dataField: "site.name",
        text: "Location Name",
        sort: true,
      },
      {
        dataField: "formattedType",
        text: "Incident Type",
        sort: true,
      },

      {
        dataField: "formattedIncidentDate",
        text: "Incident Date",
        sort: true,
      },
      {
        dataField: "generalReasons",
        text: "General-Info Reasons",
        sort: true,
        isExcelOnly: true,
      },
      {
        dataField: "formattedReportedBy",
        text: "Reported By",
        sort: true,
      },
      {
        dataField: "staffData.email",
        text: "Email ID",
        sort: true,
        isExcelOnly: true,
      },
      {
        dataField: "staffData.employeeId",
        text: "Emp ID",
        sort: true,
        isExcelOnly: true,
      },
      {
        dataField: "staffData.designation",
        text: "Designation",
        sort: true,
        isExcelOnly: true,
      },
      {
        dataField: "formattedDesignation",
        text: "Designation",
        sort: true,
        isTableOnly: true,
      },
      {
        dataField: "formattedSeverity",
        text: "Severity",
        sort: true,
      },

      {
        dataField: "area.name",
        text: "Area",
        sort: true,
      },

      {
        dataField: "department.name",
        text: "Department",
        sort: true,
      },
      {
        dataField: "formattedIncidentStatus",
        text: "Status",
        sort: true,
      },
      {
        dataField: "shift",
        text: "Shift",
        sort: true,
      },
      {
        dataField: "formattedStaffType",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "createdAtView",
        text: "Time Stamp",
        sort: true,
      },

      {
        dataField: "create",
        text: "Action",
        formatter: (_rowContent, row) => {
          let linkData = checkViewAndEditPermission(row);
          let editLink = linkData.editLink;
          let viewLink = linkData.viewLink;

          let showEditIcon = false;

          if (
            isUserRO() &&
            checkUserIsOfSameSite(row?.siteId) &&
            checkStringsAreEqual(row.incidentStatus, incidentStatuses.draft)
          ) {
            showEditIcon = true;
          }
          if (
            isUserSO() &&
            checkUserIsOfSameSite(row?.siteId) &&
            (checkStringsAreEqual(row.incidentStatus, incidentStatuses.open) ||
              checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaCompleted)) &&
            checkStringsAreEqual(row.reportAtLabel, "so")
          ) {
            showEditIcon = true;
          }
          if (
            isUserMM() &&
            checkUserIsOfSameSite(row?.siteId) &&
            (checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaReviewed) ||
              checkStringsAreEqual(
                row.incidentStatus,
                incidentStatuses.investigationCompleted
              ) ||
              checkStringsAreEqual(row.incidentStatus, incidentStatuses.mmReview)) &&
            checkStringsAreEqual(row.reportAtLabel, "mm")
          ) {
            showEditIcon = true;
          }
          if (
            isUserInvestigatorOfIncident(row) &&
            checkUserIsOfSameSite(row?.siteId) &&
            checkStringsAreEqual(
              row.incidentStatus,
              incidentStatuses.investigationProgress
            )
          ) {
            showEditIcon = true;
          }

          // if (row.incidentStatus === incidentStatuses.initialReview || row.incidentStatus === incidentStatuses.open) permissionName = "investigator";
          // else if (row.incidentStatus === incidentStatuses.investigation) permissionName = "reviewer";
          // else if (row.incidentStatus === incidentStatuses.finalReview) permissionName = "closer";

          return (
            <div className="actionIconsGroup">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">View</Tooltip>}
              >
                <Link className="icons text-cyanBlue" to={viewLink}>
                  <FiEye />
                </Link>
              </OverlayTrigger>

              {viewIncident &&
                row?.isPersonalInjury &&
                !row?.ltiHoursUpdate &&
                checkLtiWithType.includes(row?.type) &&
                (isUserMM() || isUserSO()) && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Update LTI info</Tooltip>}
                  >
                    <Link
                      className="icons text-cyanBlue"
                      to={`/health-safety-and-environment/incident-management/update-lti-info/${row?.id}`}
                    >
                      <FiEdit3 />
                    </Link>
                  </OverlayTrigger>
                )}

              {showEditIcon && !viewIncident && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                >
                  <Link className="icons text-cyanBlue" to={editLink}>
                    <FiEdit3 />
                  </Link>
                </OverlayTrigger>
              )}

              <DeleteRecordIcon
                id={row.id}
                moduleType={moduleType.ehsIncidentDetails}
                setLoading={setLoading}
                reloadData={fetchData}
              />
            </div>
          );
        },
      },
    ],
    [
      checkViewAndEditPermission,
      fetchData,
      isUserInvestigatorOfIncident,
      siteId,
      viewIncident,
    ]
  );

  const finalIncidentFilterFields = useMemo(
    () =>
      incidentFilterFields?.map((d) => {
        if (d.name === "incidentStatus") {
          const statusOption = d?.options?.filter((status) => status.value !== "Draft");
          return { ...d, options: statusOption };
        }
        return d;
      }),
    []
  );

  const onSearchFilter = useCallback(
    (props) => {
      let value = props?.searchProps?.searchText;
      if (searchFilter?.search !== props?.searchProps?.searchText) setSearchFilter(value);
    },
    [searchFilter?.search]
  );

  useEffect(() => {
    let flag = 0;
    const checkObj = Object.values(filterForm)?.map((d) => {
      if (d) flag++;
    });
    if (flag === 0) {
      setStatusTabFilter(incidents);
      setFilterFlag(true);
    }
  }, [filterForm, incidents]);

  useEffect(() => {
    dispatchFunction(filterActionAdd({ manageIncidentSearch: searchFilter }));
  }, [searchFilter]);

  const onReset = useCallback(() => {
    setFilterForm({});
    // setStatusTabFilter(incidentsFilter);
    setFilterFlag(false);
  }, []);
  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Incident Management",
            path:
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/incident-management",
          },
          { name: "View Incidents", path: "#" },
        ]}
        module={ACTIVE_MODULE.incident}
      />

      <div className="card p-3">
        <div className="simple-card-title">
          <h3 class="text-capitalize mb-0">
            {viewIncident ? "View" : "Manage"} Incidents
          </h3>
          <FilterBtn setShowFilter={setShowFilter} />
          <BackBtn
            url={
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/incident-management"
            }
          />
        </div>

        <Row className="searchIncident">
          <Col lg={12}>
            <div className="incidentRadioInner">
              <div className="incidentCols">
                <label className="customIncidentRadio">
                  <input
                    type="radio"
                    name={"incidentStatus"}
                    value="All"
                    onChange={onChange}
                    checked={filter.incidentStatus === "All"}
                  />
                  <span className="labelTxt">All ({statusTabFilter.length})</span>
                  <span className="checkmark"></span>
                </label>
              </div>
              {Object.keys(incidentStatuses).map((key) =>
                key === "draft" ? null : (
                  <Fragment>
                    <div key={key} className="incidentCols">
                      <label className="customIncidentRadio">
                        <input
                          type="radio"
                          name={"incidentStatus"}
                          value={incidentStatuses[key]}
                          onChange={onChange}
                          checked={filter.incidentStatus === incidentStatuses[key]}
                        />
                        <span className="labelTxt">
                          {incidentStatuses[key]} (
                          {TAB_STATUS_COUNT(statusTabFilter, incidentStatuses[key])})
                        </span>
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </Fragment>
                )
              )}
            </div>
          </Col>
        </Row>

        {!loading ? (
          <SearchBootstrapTable
            searchKey={"viewIncidentsIMDesktopSearch"}
            data={incidentsFilter}
            columns={sortableColumn}
            tableBeforeSearch={() =>
              showFilter ? (
                <IncidentFilters
                  fields={finalIncidentFilterFields}
                  setForm={setFilterForm}
                  form={filterForm}
                  onChange={onChangeFilter}
                  onReset={onReset}
                  isViewIncident
                />
              ) : (
                <></>
              )
            }
            tableKey="viewIncidentsIM"
            defaultHideColumn={["reportedBy", "site.siteId"]}
          />
        ) : (
          <NetZeroLoader />
        )}
      </div>
    </div>
  );
};

export default ManageIncidents;
